export default __webpack_public_path__ + "static/media/Emil-Digitallabs.c798c608.jpeg";